export const defaultLocale = 'en-US';
export type FormLocales = 'en-US' | 'de-DE';

export const localeMapper: Record<string, FormLocales> = {
  en: 'en-US',
  de: 'de-DE',
};

export const localeToLanguageCodeMapper: Record<FormLocales, string> = {
  'en-US': 'en',
  'de-DE': 'de',
};
